// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4p-0";
export var eligibilityCardNotEligible = "_4p-1";